<!-- MODAL anulacionDoc -->
<div mdbModal #anulacionDoc="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">Anulación de documento</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="CloseModal()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <form autocomplete="off" [formGroup]="formHeader">
          <div class="row">
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <input value="" type="text" id="proveedor" class="form-control" placeholder="" required
                  formControlName="rutProveedor" formatRut #rutEmisor />
                <label for="proveedor">Proveedor</label>
                <div *ngIf="
              formHeader.get('rutProveedor').invalid &&
              (formHeader.get('rutProveedor').dirty ||
              formHeader.get('rutProveedor').touched)
            ">
                  <mdb-error *ngIf="formHeader.get('rutProveedor').hasError('required')">Ingrese Proveedor
                  </mdb-error>
                </div>
              </div>

            </div>
            <div class="col d-flex" style="max-width: 265px">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="openModalSeleccionarProveedor()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 class="text-info" *ngIf="proveedorSeleccionado" style="display: contents">
                {{ proveedorSeleccionado.nombre }}
              </h6>
            </div>
            <div class="col" style="max-width: 300px">
              <div class="md-form">
                <mdb-select [disabled]="true" formControlName="tipoFact" [options]="optionsTipoFact" [multiple]="false"
                  [filterEnabled]="true" [highlightFirst]="false" placeholder="Seleccionar tipo de documento">
                </mdb-select>
                <label>Tipo de Documento</label>
                <!-- <mdb-error *ngIf="formHeader.get('tipoDocumento').hasError('required')">Ingrese tipo de documento
                                </mdb-error> -->
              </div>
            </div>
          </div>
          <div class="row" style="padding-top: 2%">
            <div class="col " style="max-width: 200px;">
              <div class="md-form">
                <input value="" type="text" id="nroDoc" class="form-control" placeholder="000" #nroDoc
                  formControlName="nroDoc" onlyNumbers />
                <label for="nroDoc">Nro. Doc.</label>
              </div>
            </div>
            <div class="col" style="max-width: 33%">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="abrirModalSeleccionDocumento()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
            </div>
            <!-- <div class="col">
                <mdb-checkbox formControlName="MueveInventario">
                  Mueve Inventario
                </mdb-checkbox>
                </div> -->
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <mdb-select label="Bodega" formControlName="tipoBodega" [options]="optionsBodega"
                  placeholder="Seleccionar Bodega" [filterEnabled]="true">
                </mdb-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="max-width: 200px; margin-right: 4%;">
              <div class="md-form">
                <input value="" (input)="OnChangeFolio($event.target.value)" type="text" id="proveedor" class="form-control" placeholder="" formControlName="nFolio"
                  required />
                <label class="title">Folio</label>
                <div *ngIf="
                    formHeader.get('nFolio').invalid &&
                    (formHeader.get('nFolio').dirty ||
                    formHeader.get('nFolio').touched)
                  ">
                  <mdb-error *ngIf="formHeader.get('nFolio').hasError('required')">Ingrese folio
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 200px; margin-right: 4%">
              <div class="md-form">
                <mdb-select [options]="optionsMonth" [filterEnabled]="true" [highlightFirst]="false" placeholder="Mes"
                  formControlName="mes"></mdb-select>
                <label class="title">Periodo Ingreso</label>
                <span class="value" *ngIf="dataCabecera; else dummyTxt"></span>

              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <mdb-select [options]="optionsYear" [filterEnabled]="true" [highlightFirst]="false" placeholder="Año"
                  formControlName="anho"></mdb-select>
                <label class="title">Gestión</label>
                <span class="value" *ngIf="dataCabecera; else dummyTxt"></span>
                <ng-template #dummyTxt>
                  <div class="dummyTxt"></div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col" style="max-width: 150px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaInicio" formControlName="FechaDoc"
                  [placeholder]="'Fecha Doc.'" required>
                </mdb-date-picker>
                <label for="FechaDoc">Fecha de Emision</label>
                <div *ngIf="
              formHeader.get('FechaDoc').invalid &&
              (formHeader.get('FechaDoc').dirty ||
              formHeader.get('FechaDoc').touched)
            ">
                  <mdb-error *ngIf="formHeader.get('FechaDoc').hasError('required')">Ingrese fecha de Doc.
                  </mdb-error>
                </div>
              </div>
            </div>

            <div class="col" style="max-width: 150px;">
              <div class="md-form">
                <mdb-date-picker [inline]="true" name="fechaFinal" formControlName="FechaVenc"
                  [placeholder]="'Fecha de Vencimiento'" required>
                </mdb-date-picker>
                <label for="FechaVenc">Fecha de vencimiento</label>
                <div *ngIf="
              formHeader.get('FechaVenc').invalid &&
              (formHeader.get('FechaVenc').dirty ||
              formHeader.get('FechaVenc').touched)
            ">
                  <mdb-error *ngIf="formHeader.get('FechaVenc').hasError('required')">Ingrese fecha de Vencimiento
                  </mdb-error>
                </div>
              </div>
            </div>


          </div>
        </form>

          <!-- Totales -->
          <div class="row">

            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle">
                <tbody class="blue lighten-5">
                  <tr>
                    <!-- <td><strong>SubTotal</strong></td>
            <td><strong>Desc. Gbl</strong></td>
            <td><strong>Recargo Gbl</strong></td> -->
                    <td>
                      <div style="display: flex;">
                        <strong>Monto Neto</strong>
                      </div>
                    </td>
                    <td>
                      <div style="display: flex;">
                        <strong>Monto Exento</strong>
                      </div>
                    </td>
                    <td><strong>Desc. Global</strong></td>
                    <td><strong>Recar. Global</strong></td>
                  </tr>
                </tbody>
                <tbody class="blue lighten-5">
                  <tr>
                    <td align="right">
                      <input value="" (input)="OnChangeTotalxAfecto($event.target.value)" [(ngModel)]="MontoAf"
                        type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" (input)="OnChangeTotalxExento($event.target.value)" [(ngModel)]="MontoEx"
                        type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="DescGbl" type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="RecargoGbl" type="text" class="form-control" placeholder="..."
                        monto />
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle">
                <tbody class="blue lighten-5">
                  <tr>
                    <td align="right">
                      <div style="display: flex;">
                        <strong> Monto IVA</strong>
                      </div>
                    </td>
                    <td><strong>IVA Recuperable</strong></td>
                    <td><strong>IVA No-Recuperable</strong></td>
                    <td><strong>IVA Activo Fijo</strong></td>
                    <td><strong>IVA Retenido</strong></td>
                    <td><strong>IVA en Comun</strong></td>
                  </tr>
                </tbody>
                <tbody class="blue lighten-5">
                  <tr>
                    <td align="right">
                      <input value="" (input)="OnChangeTotalxIva($event.target.value)" [(ngModel)]="MontoIva"
                        type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="IvaRec" type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="IvaNoRec" type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="IvaActF" type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="IvaRet" type="text" class="form-control" placeholder="..." monto />
                    </td>
                    <td align="right">
                      <input value="" [(ngModel)]="IvaComn" type="text" class="form-control" placeholder="..." monto />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive">
              <table class="table table-striped table-hover table-sm align-middle">
                <tbody class="blue lighten-5">
                  <tr>
                    <td align="right"><strong>Total Bruto</strong></td>
                  </tr>
                </tbody>
                <tbody class="blue lighten-5">
                  <tr>
                    <td align="right">
                      <strong>{{ TotalBruto | numerico }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>


          </div>
          <form autocomplete="off" [formGroup]="formMotivoGeneral">
          <div class="row">
            <div class="col" style="max-width: 200px">
              <div class="md-form">
                <mdb-select [options]="optionsMotivoGeneral" placeholder="Seleccionar motivo" [filterEnabled]="true"
                  formControlName="motivo">
                </mdb-select>
                <label class="title">Motivo</label>
                <div *ngIf="
                formMotivoGeneral.get('motivo').invalid &&
                (formMotivoGeneral.get('motivo').dirty ||
                formMotivoGeneral.get('motivo').touched)
              ">
                  <mdb-error *ngIf="formMotivoGeneral.get('motivo').hasError('required')">Seleccione un Motivo
                  </mdb-error>
                </div>
              </div>
            </div>
          </div>
          </form>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal" (click)="CloseModal()"
              mdbWavesEffect>Cerrar</button>
            <button [disabled]="(Existefolio  == '' || Existefolio == null)" mdbBtn type="submit" class="btn btn-sm" color="secondary" size="sm" mdbWavesEffect
              (click)="SaveAnulacion()">
              Guardar
            </button>
          </div>
          <div class="modal-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
            <div></div>
          </div>
      </div>
    </div>
  </div>
</div>

<app-modal-seleccion-documento [tipo_dte_codigo]="doctoReferencia" [tipo_ncnd]="3" [es_nd]="false"
  (onSelect)="onDocumentoSeleccionado($event)" (onNotFound)="onNotFoundDocumento()">
</app-modal-seleccion-documento>

<!-- MODAL seleccionarProveedor -->
<app-modal-seleccionar-proveedor [multiple]="false" (onSelect)="onProveedorSeleccionado($event)" queryType="ONLY_RUT"
  showInfoProveedorInactivoBloqueado="true" (onNotFound)="onProveedorNoEncontrado()">
</app-modal-seleccionar-proveedor>
